import { render, staticRenderFns } from "./TestRequestWrapper.vue?vue&type=template&id=4314c2de&lang=pug"
import script from "./TestRequestWrapper.vue?vue&type=script&lang=js"
export * from "./TestRequestWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports